import axios from 'axios'

import { REACT_APP_SITE_KEY, REACT_APP_API_URL } from '../shared/vars'

export default class PermalinkChecker {
    constructor(table, id = ''){
        this.table = table
        this.id = id
    }

    checkPermalink(value){
        const data = {
            string: value,
            id: this.id,
            check: this.table
        }

        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }
        return axios.post(REACT_APP_API_URL + 'permalinks', data, { headers: AUTH_HEADER })
        .then(response => {
            if(response.data.status !== 200){
                return Promise.reject(response.data.message)
            }
            return response.data.message.permalink
        })
        .catch(err => {
            return Promise.reject(err)
            // console.log(err)
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/PermalinkChecker.js